"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

require("./Alert.css");

var utils = _interopRequireWildcard(require("../../shared"));

var _AlertAction = _interopRequireDefault(require("./AlertAction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Alert(_ref) {
  var Component = _ref.componentEl,
      className = _ref.className,
      icon = _ref.icon,
      margin = _ref.margin,
      onDismiss = _ref.onDismiss,
      type = _ref.type,
      fullWidth = _ref.fullWidth,
      floating = _ref.floating,
      children = _ref.children,
      autoDismiss = _ref.autoDismiss,
      autoDismissTime = _ref.autoDismissTime,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "icon", "margin", "onDismiss", "type", "fullWidth", "floating", "children", "autoDismiss", "autoDismissTime"]);

  var cssClasses = ['st_alert', "st_alert--" + type];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  if (fullWidth) cssClasses.push('st_alert--fullwidth');
  if (floating) cssClasses.push('st_alert--floating');
  var dismissTimer = (0, _react.useRef)(false); // set timer for autodismiss

  (0, _react.useEffect)(function () {
    if (autoDismiss) {
      dismissTimer.current = setTimeout(function () {
        if (onDismiss) onDismiss();
      }, autoDismissTime * 1000);
      return function () {
        return dismissTimer.current && clearTimeout(dismissTimer.current);
      };
    }

    return undefined;
  }, [autoDismiss, onDismiss, autoDismissTime]); // handle when X is clicked to manually close Alert

  function handleDismissClick() {
    clearTimeout(dismissTimer.current);
    if (onDismiss) onDismiss();
  }

  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_alert__content"
  }, icon ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: icon,
    size: "md",
    className: "st_alert__icon"
  }) : null, children), onDismiss && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: handleDismissClick,
    size: "md",
    className: "st_alert__dismiss"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: "cross",
    alt: "dismiss"
  })));
}

Alert.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** margin for avatar, if any */
  margin: utils.spacing.marginProps,

  /** type of alert */
  type: _propTypes["default"].oneOf(['primary', 'success', 'warning', 'error', 'gray']),

  /** whether component should go edge to edge */
  fullWidth: _propTypes["default"].bool,

  /** whether component should be overlaid in the middle of the viewport */
  floating: _propTypes["default"].bool,

  /** optional icon to be displayed to the left */
  icon: _propTypes["default"].string,

  /** callback when alert is dismissed, setting this lets X appear */
  onDismiss: _propTypes["default"].func,

  /** whether to fire onDismiss automatically after X seconds */
  autoDismiss: _propTypes["default"].bool,

  /** how many seconds to wait before firing onDismiss automatically */
  autoDismissTime: _propTypes["default"].number
};
Alert.defaultProps = {
  componentEl: utils.componentEl.defaults,
  type: 'primary',
  fullWidth: false,
  floating: false,
  margin: null,
  className: null,
  icon: null,
  onDismiss: null,
  autoDismiss: false,
  autoDismissTime: 3
};
Alert.Action = _AlertAction["default"];
var _default = Alert;
exports["default"] = _default;